import MDBox from 'components/MDBox';
import { formatNumber } from 'layouts/player-management/helpers';

export const playerColumnData = () => [
    // { Header: 'ID', accessor: 'id', width: 100 },
    {
      Header: 'Username',
      accessor: 'nickname',
      width: 100,
      Cell: (cellProps) => {
        const isRegularUser =
          !cellProps.cell.row.original.isDemo && !cellProps.cell.row.original.isPromoCodeUser ? true : false;
        const isPromoCodeUser = cellProps.cell.row.original.isPromoCodeUser ? true : false;

        let params = '';
        if (!isRegularUser) {
          if (isPromoCodeUser) {
            params = '?isPromoCodeUser=true';
          } else {
            params = '?isDemo=true';
          }
        }
        return (
          <MDBox
            component='td'
            textAlign={cellProps.cell.column.align ? cellProps.cell.column.align : 'left'}
            py={1.5}
            pl={cellProps.cell.row.isExpanded ? 1.5 : 3}
            sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
              fontSize: size.sm,
              fontWeight: cellProps.cell.row.isExpanded ? 600 : 400
            })}
          >
            {/* <Link
              to={
                // cellProps.cell.row.isExpanded &&
                // cellProps.cell.row.original.isDemo &&
                cellProps.cell.column?.id === 'nickname' || cellProps.cell.column?.id === 'username'
                  ? `/player-management/show/${cellProps.cell.row.original?.id}${params}`
                  : ''
              }
              sx={{
                verticalAlign: 'middle',
                textDecoration: 'none',
                cursor:
                  // cellProps.cell.row.isExpanded &&
                  // cellProps.cell.row.original.isDemo &&
                  cellProps.cell.column?.id === 'nickname' || cellProps.cell.column?.id === 'username'
                    ? 'pointer'
                    : 'default'
              }}
            > */}
            <MDBox
              display='inline-block'
              width='max-content'
              color='text'
              sx={{
                verticalAlign: 'middle',

                textDecoration:
                  // cellProps.cell.row.isExpanded &&
                  // cellProps.cell.row.original.isDemo &&
                  cellProps.cell.column?.id === 'nickname' || cellProps.cell.column?.id === 'username'
                    ? 'underline '
                    : 'none',
                cursor:
                  // cellProps.cell.row.isExpanded &&
                  // cellProps.cell.row.original.isDemo &&
                  cellProps.cell.column?.id === 'nickname' || cellProps.cell.column?.id === 'username'
                    ? 'pointer'
                    : 'default'
              }}
            >
              {cellProps.cell.row.original.nickname}
            </MDBox>
            {/* </Link> */}
          </MDBox>
        );
      },
      SubCell: (cellProps) => {
        return <>{cellProps.value}</>;
      }
    },
    {
      Header: 'Email',
      accessor: 'email',
      width: 150,
      Cell: (cellProps) => <>{cellProps.value}</>,
      SubCell: (cellProps) => <>{cellProps.value}</>
    },
    // {
    //   Header: 'Current Balance',
    //   accessor: 'current_balance',
    //   width: 150,
    //   Cell: (cellProps) => <>{formatNumber(cellProps.value)}</>,
    //   SubCell: (cellProps) => <>{formatNumber(cellProps.value)}</>
    // },
    {
      Header: 'Coins Amount',
      accessor: 'coinsAmount',
      width: 150,

      Cell: (cellProps) => <>{formatNumber(cellProps.value)}</>,
      SubCell: (cellProps) => <>{formatNumber(cellProps.value)}</>
    },
    {
      Header: 'Gems Amount',
      accessor: 'gemsAmount',
      width: 150,

      Cell: (cellProps) => <>{formatNumber(cellProps.value)}</>,
      SubCell: (cellProps) => <>{formatNumber(cellProps.value)}</>
    },
    {
      Header: 'VIP',
      accessor: 'vip',
      width: 80,
      Cell: (cellProps) => <>{cellProps.value > 0 ? 'true' : 'false'}</>,
      SubCell: (cellProps) => <>{cellProps.value > 0 ? 'true' : 'false'}</>
    },
    // {
    //   Header: 'Spent',
    //   accessor: 'money_spent',
    //   width: 100,
    //   Cell: (cellProps) => <>{formatNumber(cellProps.value)}</>,
    //   SubCell: (cellProps) => <>{formatNumber(cellProps.value)}</>
    // },
    // {
    //   Header: 'Cashout',
    //   accessor: 'money_cashed_out',
    //   width: 100,
    //   Cell: (cellProps) => <>{formatNumber(cellProps.value)}</>,
    //   SubCell: (cellProps) => <>{formatNumber(cellProps.value)}</>
    // },
    {
      Header: 'wallet',
      accessor: 'wallet',
      width: 200,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.isDemo && !row.original.isPromoCodeUser
              ? process.env.REACT_APP_FRONTEND_URL + '?demoId=' + row.original.id
              : row.original.id}
          </>
        );
      }
    },
    { Header: 'location', accessor: 'country', width: 200 },
    { Header: 'Country Code', accessor: 'countryCode', width: 200 },
    { Header: 'Demo User', accessor: 'isDemo', width: 100, Cell: (cellProps) => (cellProps.value ? 'true' : 'false') },
    {
      Header: 'Creation Date',
      accessor: 'createdAt',
      Cell: (cellProps) => (
        <MDBox color='none' sx={{ marginRight: '20px' }}>
          {cellProps.value}
        </MDBox>
      ),
      SubCell: (cellProps) => <>{cellProps.value}</>
    }
  ];
